export default __webpack_public_path__ + "static/media/info.574d7d03.svg";